import { ShipmentSku } from "./../../../../models/shipyard.model";
import { FormControl, Validators } from "@angular/forms";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogActions } from '../../../../components/dialogs/dialog.model';
import { Subject } from "rxjs";

@Component({
  selector: "app-update-sku-qty",
  templateUrl: "./update-sku-qty.component.html",
  styleUrls: ["./update-sku-qty.component.scss"],
})
export class UpdateSkuQtyComponent implements OnInit,OnDestroy {
  qtyInput: FormControl;
  actions: any[];
  private destroy$ = new Subject<void>();
  draftAction: any;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      description?: string;
      inputLabel: string;
      sku: ShipmentSku;
      prefilQty: number;
      maxQty: number;
      minQty: number;
      print: boolean;
      status:string;
      isShowAlert:boolean;
      confirmationButton: string;
      callBackFn: (dialogRef: MatDialogRef<any> , qty: number, actions: DialogActions[]) => void;
      isDraftShipment:boolean;
     
    },
    public dialogRef: MatDialogRef<UpdateSkuQtyComponent>
  ) {}

  ngOnInit(): void {
    this.qtyInput = new FormControl(this.data.prefilQty, [
      Validators.required,
      Validators.max(this.data.maxQty),
      Validators.min(this.data.minQty || 1),
    ]);

    this.actions = [
      { text: "Cancel", buttonStyle: "underline" },
      { text: this.data.isDraftShipment ? "confirm" : "Save", isDisabled: !this.qtyInput.valid && !this.data.isDraftShipment},
    ];
    if (this.data.print) {
      this.actions.push({
        text: "Save & Print",
        isDisabled: !this.qtyInput.valid,
      });
    } 
    this.draftAction= 'Keep Draft';   
  }

  action(event) {
    if (event === "Save" || event === "confirm") {
      if (this.data.confirmationButton &&
          this.data.confirmationButton === event &&
          this.data.callBackFn) {
        this.actions[1].spin = true;
        this.data.callBackFn(this.dialogRef, this.qtyInput.value, this.actions);
      } else if(this.data.isDraftShipment) {
        this.dialogRef.close(this.draftAction);
      } else {
        this.dialogRef.close(this.qtyInput.value);
      }
    } else if (event === "Save & Print") {
      const result = {
        print: true,
        value: this.qtyInput.value,
      };
      this.dialogRef.close(result);
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  inputChange(event: Event) {
    this.actions[1].isDisabled = !this.qtyInput.valid;
    if (this.data.print) {
      this.actions[2].isDisabled = !this.qtyInput.valid;
    }
  }

  onChange(e)
  {
    this.draftAction= e ? 'Keep Draft' : 'Delete Draft';
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
